module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/5n7QqpN19UZ0BHFKyK32ng-8aedd84a7d493cdd34b233414e25a433.jpg";